module.exports = __webpack_public_path__ + "images/marketing/dan_beres.jpg";